import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";
import CreditNotesForm from "@/components/invoices/credits/credit-notes-form";
import { Skeleton } from "@/components/ui/skeleton";

export const Route = createFileRoute(
  "/_authenticated/invoices/credit-notes/$creditNoteId/edit",
)({
  component: EditCreditNotePage,
});

function EditCreditNotePage() {
  const { creditNoteId } = Route.useParams();

  const creditNote = useQuery(
    api.companies.credit_notes.queries.getCreditNoteById,
    { creditNoteId: creditNoteId as Id<"credit_notes"> },
  );

  if (creditNote === undefined) {
    return (
      <div className="space-y-4 p-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  if (!creditNote) {
    return (
      <div className="flex flex-col items-center justify-center p-12">
        <p className="text-lg font-semibold text-muted-foreground">
          Nota de crédito no encontrada
        </p>
      </div>
    );
  }

  // Documento fiscal: solo los borradores son editables. Emitidas/anuladas se
  // abren en modo solo lectura (misma vista, sin edición ni autosave).
  const readOnly = creditNote.status !== "draft";

  return (
    <CreditNotesForm creditNote={creditNote as any} readOnly={readOnly} />
  );
}
